import React, { useCallback, useEffect } from 'react'
import SideBar from './SideBar'
import axiosClient from '../axios';
import '../assets/css/userTable.css'
import loaderImg from '../assets/images/loader.gif'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Edit, MoreHoriz } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { dateConvert } from '../dateConverter';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, Autocomplete } from '@mui/material';
import Pagination_2 from './Pagination_2';
import moment from 'moment';
import { ReactComponent as Config } from "../assets/images/config.svg"
import { ReactComponent as Cross } from "../assets/images/cross.svg"
import { debounce } from 'lodash';
import "../assets/css/AdminCommon.css";

const SpinWheelRewards = () => {
    const [spinWheelData, setSpinWheelData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [show, setShow] = useState(false)
    const [userCount, setUserCount] = useState(false)
    const [rewardType, setRewardType] = useState([1, 2, 3])
    const [totalCount, setTotalCount] = useState(0)
    const [platformData, setPlatFormData] = useState([])
    const [partnerBonusData, setPartnerBonusData] = useState([])

    const [pagination, setPagination] = useState({
        page: 0,
        limit: 100
    });

    const [date, setDate] = useState({
        start: null,
        end: null,
    })

    const handleDate = (e, f) => {
        if (f === 1) {
            setDate({ ...date, start: e })
            return
        }
        if (f === 2) {
            setDate({ ...date, end: e })
            return
        }
    }

    const getSpinWheelData = () => {
        setIsLoading(false)
        let data = {
            s_date: date.start ? dateConvert(date.start) : null,
            e_date: date.end ? dateConvert(date.end) : null,
            page: pagination.page,
            limit: pagination.limit,
            fetchCount: userCount,
            rewardType: rewardType
        }
        axiosClient
            .post("/get-spin-wheel-data", data)
            .then((res) => {
                setSpinWheelData(res.data.response?.totalData)
            })
            .catch((error) =>
                console.log(error)
            ).finally(() => setIsLoading(true))
    }

    const handleSpinWheelData = () => {
        if (date.start && date.end && date.start > date.end) {
            alert("Start Date should be previous to End Date")
            return
        }

        if (rewardType?.length === 0) {
            alert("Please Select Atleat one Reward Type...")
            return
        }

        let data = {
            s_date: date.start ? dateConvert(date.start) : null,
            e_date: date.end ? dateConvert(date.end) : null,
            page: pagination.page,
            limit: pagination.limit,
            fetchCount: userCount,
            rewardType: rewardType,
        }

        setIsLoading(false)
        axiosClient
            .post(`/get-spin-wheel-data`, data)
            .then((res) => {
                if (!userCount) {
                    setSpinWheelData(res.data.response?.totalData || [])
                }
                setPlatFormData(res.data.response?.platformBonus || [])
                setPartnerBonusData(res.data.response?.partnerBonusData || [])
                setTotalCount(res?.data?.response.totalCount)
                setUserCount(false)
            })
            .catch((error) =>
                console.log(error)
            ).finally(() => {
                setShow(false)
                setIsLoading(true)
            })
    }

    const handleRewardType = (val) => {
        setRewardType((prev) => prev.includes(val) ? prev.filter((v) => v != val) : [...prev, val])
    }

    const getPlatformBonus = (id) => {
        let bonus = platformData?.find((item) => (item?._id || item?._id?.partnerId) === id)
        return bonus?.totalBonus || 0;
    }

    const getPartnerBonus = (userid, partnerid) => {
        let bonus = partnerBonusData?.find((item) => (item?.userId == userid) && (item?.partnerId == partnerid))
        return bonus?.totalBonus || 0;
    }

    useEffect(() => {
        getSpinWheelData();
    }, [pagination.page, pagination.limit])

    return (
        <>
            <SideBar handleSideBar={true} activeTab={"SpinWheelReward"} />
            <div className="screen">

                {/* Header Section */}
                <div className="admin-header-v4">
                    <h2>Spin Wheel Rewards</h2>
                    <div style={{ display: "flex", gap: "var(--spacing-md)", alignItems: "center" }}>
                        <div className="pagination-info-v4">
                            Total Records: {totalCount}
                        </div>
                        <button onClick={() => setShow(!show)} className="btn-secondary-v4">
                            {show ? "Hide Filters" : "Filters"}
                        </button>
                    </div>
                </div>

                {/* Filter Section */}
                {show && (
                    <div className="admin-form-container-v4" style={{ marginBottom: "var(--spacing-xl)" }}>
                        <div className="offer-settings-grid-v4" style={{ marginBottom: "var(--spacing-lg)" }}>
                            {/* User Count Toggle */}
                            <div className="form-group-v4">
                                <label className="form-label-v4">Get User Count</label>
                                <div className="radio-group-v4">
                                    <label className="radio-option-v4">
                                        <input
                                            type="radio"
                                            checked={!userCount}
                                            onChange={() => setUserCount(false)}
                                        />
                                        <span>False</span>
                                    </label>
                                    <label className="radio-option-v4">
                                        <input
                                            type="radio"
                                            checked={userCount}
                                            onChange={() => setUserCount(true)}
                                        />
                                        <span>True</span>
                                    </label>
                                </div>
                            </div>

                            {/* Reward Type Selection */}
                            <div className="form-group-v4">
                                <label className="form-label-v4">Reward Type</label>
                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "var(--spacing-sm)",
                                    padding: "var(--spacing-md)",
                                    background: "var(--bg-input)",
                                    borderRadius: "var(--radius-md)",
                                    border: "2px solid var(--border-color)"
                                }}>
                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                                        <input
                                            type="checkbox"
                                            checked={rewardType?.includes(1)}
                                            onChange={() => handleRewardType(1)}
                                            className="checkbox-input-v4"
                                        />
                                        <span style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                                            Complete Amount
                                        </span>
                                    </label>
                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                                        <input
                                            type="checkbox"
                                            checked={rewardType?.includes(2)}
                                            onChange={() => handleRewardType(2)}
                                            className="checkbox-input-v4"
                                        />
                                        <span style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                                            Partner Bonus
                                        </span>
                                    </label>
                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                                        <input
                                            type="checkbox"
                                            checked={rewardType?.includes(3)}
                                            onChange={() => handleRewardType(3)}
                                            className="checkbox-input-v4"
                                        />
                                        <span style={{ fontSize: "14px", color: "var(--text-secondary)" }}>
                                            Platform Bonus
                                        </span>
                                    </label>
                                </div>
                            </div>

                            {/* Start Date */}
                            <div className="form-group-v4">
                                <label className="form-label-v4">Start Date</label>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={date.start}
                                        onChange={(value) => handleDate(value, 1)}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                    />
                                </LocalizationProvider>
                            </div>

                            {/* End Date */}
                            <div className="form-group-v4">
                                <label className="form-label-v4">End Date</label>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={date.end}
                                        onChange={(value) => handleDate(value, 2)}
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div style={{ display: "flex", gap: "var(--spacing-md)" }}>
                            <button className="submit-button-v4" onClick={handleSpinWheelData}>
                                Apply Filters
                            </button>
                            <button className="cancel-button-v4" onClick={() => {
                                setDate({ start: null, end: null });
                                setRewardType([1, 2, 3]);
                                setUserCount(false);
                            }}>
                                Reset Filters
                            </button>
                        </div>
                    </div>
                )}

                {/* Data Table Section */}
                {!isLoading ? (
                    <div className="loader-container-v4">
                        <img src={loaderImg} alt="loader" className="loader-image-v4" />
                    </div>
                ) : (
                    <div className="admin-form-container-v4">
                        {spinWheelData.length > 0 ? (
                            <>
                                <div style={{ marginTop: "var(--spacing-xl)" }}>
                                    <Pagination_2
                                        filterDataInput={pagination}
                                        setFilterDataInput={setPagination}
                                        showNext={spinWheelData?.length === pagination.limit}
                                    />
                                </div>
                                <div className="table-container-v4">
                                    <table className="data-table-v4">
                                        <thead>
                                            <tr>
                                                <th>S.NO.</th>
                                                <th>User Name</th>
                                                <th>Phone Number</th>
                                                <th>Email Id</th>
                                                <th>Earning</th>
                                                <th>Reward Type</th>
                                                <th>Partner Name</th>
                                                <th>Platform Bonus</th>
                                                <th>Partner Bonus</th>
                                                <th>Value</th>
                                                <th>Used At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {spinWheelData?.map((val, key) => (
                                                <tr key={key}>
                                                    <td>{(pagination.page * pagination.limit) + (key + 1)}</td>
                                                    <td className="text-link-v4"
                                                        onClick={() => window.open(`/users/transaction/${val.userId?._id}`)}
                                                        style={{ cursor: 'pointer' }}>
                                                        {val?.userId?.name || 'N/A'}
                                                    </td>
                                                    <td>{val?.userId?.phoneNumber || 'N/A'}</td>
                                                    <td>{val?.userId?.emailId || 'N/A'}</td>
                                                    <td className="amount-v4">
                                                        {val?.userId?.earnings?.toFixed(4) || '0.0000'}
                                                    </td>
                                                    <td>
                                                        <span className={`earning-badge-v4 type-${val?.rType || 0}`}>
                                                            {val?.rType == 1 ? "Complete Amount" :
                                                                val?.rType == 2 ? "Partner Bonus" :
                                                                    val?.rType == 3 ? "Platform Bonus" : "---"}
                                                        </span>
                                                    </td>
                                                    <td className="text-link-v4"
                                                        onClick={() => val.partnerId?._id && window.open(`/partner-detail/${val?.partnerId?._id}`)}
                                                        style={{ cursor: val.partnerId?._id ? 'pointer' : 'default' }}>
                                                        {val?.partnerId?.name || "---"}
                                                    </td>
                                                    <td className="amount-v4">
                                                        {val.userId?._id ? Number(getPlatformBonus(val.userId?._id)?.toFixed(4)) : "---"}
                                                    </td>
                                                    <td className="amount-v4">
                                                        {val.userId?._id && val?.partnerId?._id ?
                                                            Number(getPartnerBonus(val.userId?._id, val?.partnerId?._id)?.toFixed(4)) : "---"}
                                                    </td>
                                                    <td className="amount-v4">{val?.value || '0'}</td>
                                                    <td>
                                                        {moment.utc(val?.usedAt).local().format("MMM Do YY, h:mm:ss a")}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        ) : (
                            <div className="empty-state-v4">
                                <div className="empty-icon-v4">🎯</div>
                                <h3>No Spin Wheel Data Found</h3>
                                <p>Try applying different filters or check back later</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    )
}

export default SpinWheelRewards;
